export const CheckedHouseSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={200} height={200} fill="none">
    <path
      fill="#0038FF"
      d="M189.076 85.154c-4.58-11.162-11.6-21.512-20.619-29.356-10.577-9.2-27.263-16.29-41.371-11.275-14.598 5.189-24.365 17.63-35.192 27.746-3.802 3.552-7.961 6.92-12.894 8.898-22.593 9.056-37.938-3.293-57.972 10.703-20.035 13.995-21.74 41.987-8.526 59.687 13.215 17.7 44.758 15.23 68.629 15.23 23.871 0 20.034 16.877 61.809 17.289 42.72.421 56.206-44.896 51.586-78.813-.921-6.754-2.767-13.57-5.45-20.109Z"
    />
    <path
      fill="#fff"
      d="M189.076 85.154c-4.58-11.162-11.6-21.512-20.619-29.356-10.577-9.2-27.263-16.29-41.371-11.275-14.598 5.189-24.365 17.63-35.192 27.746-3.802 3.552-7.961 6.92-12.894 8.898-22.593 9.056-37.938-3.293-57.972 10.703-20.035 13.995-21.74 41.987-8.526 59.687 13.215 17.7 44.758 15.23 68.629 15.23 23.871 0 20.034 16.877 61.809 17.289 42.72.421 56.206-44.896 51.586-78.813-.921-6.754-2.767-13.57-5.45-20.109Z"
      opacity={0.7}
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M163.758 113.771H34.037v40.935h129.721v-40.935Z"
    />
    <path
      fill="#0038FF"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="m99.069 76.423-64.69 37.348h129.379l-64.69-37.348Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M125.181 110.444H93.08v44.261h32.101v-44.261Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M125.181 110.444H93.08v1.883h32.101v-1.883ZM117.146 154.705h-16.032v-27.666a8.016 8.016 0 0 1 16.032 0v27.666Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M99.079 120.941H24.723v33.765H99.08v-33.765Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M99.079 120.941H24.723v1.506H99.08v-1.506Z"
    />
    <path
      fill="#0038FF"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M90.897 123.726H32.905v30.98h57.992v-30.98ZM61.9 96.24l-39.46 22.783h78.923L61.901 96.239Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M101.363 119.023H22.439v1.918h78.924v-1.918Z"
    />
    <path
      fill="#0038FF"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="m109.13 97.597-20.436 11.799h40.873L109.13 97.597Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M129.567 109.396H88.694v1.894h40.873v-1.894ZM39.713 126.216h-4.696v4.697h4.696v-4.697ZM46.758 126.216H42.06v4.697h4.697v-4.697ZM53.803 126.216h-4.697v4.697h4.697v-4.697ZM60.847 126.216h-4.696v4.697h4.696v-4.697ZM67.892 126.216h-4.697v4.697h4.697v-4.697ZM74.937 126.216H70.24v4.697h4.697v-4.697ZM81.981 126.216h-4.696v4.697h4.696v-4.697ZM89.026 126.216H84.33v4.697h4.697v-4.697ZM39.713 133.127h-4.696v4.696h4.696v-4.696ZM46.758 133.127H42.06v4.696h4.697v-4.696ZM53.803 133.127h-4.697v4.696h4.697v-4.696ZM60.847 133.127h-4.696v4.696h4.696v-4.696ZM67.892 133.127h-4.697v4.696h4.697v-4.696ZM74.937 133.127H70.24v4.696h4.697v-4.696ZM81.981 133.127h-4.696v4.696h4.696v-4.696ZM89.026 133.127H84.33v4.696h4.697v-4.696ZM39.713 140.038h-4.696v4.696h4.696v-4.696ZM46.758 140.038H42.06v4.696h4.697v-4.696ZM53.803 140.038h-4.697v4.696h4.697v-4.696ZM60.847 140.038h-4.696v4.696h4.696v-4.696ZM67.892 140.038h-4.697v4.696h4.697v-4.696ZM74.937 140.038H70.24v4.696h4.697v-4.696ZM81.981 140.038h-4.696v4.696h4.696v-4.696ZM89.026 140.038H84.33v4.696h4.697v-4.696ZM39.713 146.949h-4.696v4.696h4.696v-4.696ZM46.758 146.949H42.06v4.696h4.697v-4.696ZM53.803 146.949h-4.697v4.696h4.697v-4.696ZM60.847 146.949h-4.696v4.696h4.696v-4.696ZM67.892 146.949h-4.697v4.696h4.697v-4.696ZM74.937 146.949H70.24v4.696h4.697v-4.696ZM81.981 146.949h-4.696v4.696h4.696v-4.696ZM89.026 146.949H84.33v4.696h4.697v-4.696Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M104.351 149.791v4.915"
    />
    <path fill="#222" d="M112.98 154.706v-26.142h-8.629v19.062" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M112.98 154.706v-26.142h-8.629v19.062"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M167.436 154.706h-47.427v-44.262l23.713-12.847 23.714 12.847v44.262Z"
    />
    <path
      fill="#fff"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="m171.061 112.327-27.339-14.812-27.339 14.812-.85-1.57 28.189-15.272 28.19 15.272-.851 1.57Z"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M120.009 110.444v1.076l23.713-12.847 23.714 12.847v-1.076l-23.714-12.847-23.713 12.847Z"
    />
    <path fill="#fff" d="M133.346 121.193v-4.666h20.463v23.26" />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M133.346 121.193v-4.666h20.463v23.26"
    />
    <path fill="#fff" d="M153.809 142.189v4.579h-20.463v-23.799" />
    <path
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M153.809 142.189v4.579h-20.463v-23.799"
    />
    <path
      fill="#222"
      stroke="#222"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.19}
      d="M152.445 125.616h-7.958v5.53h7.958v-5.53ZM152.445 132.965h-7.958v5.531h7.958v-5.531ZM152.445 117.891h-7.958v5.906h7.958v-5.906ZM142.668 117.891h-7.958v5.906h7.958v-5.906ZM142.668 132.965h-7.958v5.531h7.958v-5.531ZM142.668 125.616h-7.958v5.53h7.958v-5.53ZM152.445 140.315h-7.958v5.088h7.958v-5.088ZM142.668 140.315h-7.958v5.088h7.958v-5.088Z"
    />
    <path
      fill="#0038FF"
      d="M74.507 47c0-2.77 3.76-5.996 3.077-8.551-.707-2.644-5.596-3.555-6.935-5.87-1.358-2.347.282-7.033-1.623-8.938-1.905-1.906-6.591-.265-8.938-1.623-2.314-1.34-3.226-6.229-5.87-6.935-2.554-.683-5.78 3.077-8.55 3.077-2.77 0-5.997-3.76-8.552-3.077-2.643.706-3.555 5.596-5.87 6.935-2.347 1.358-7.033-.282-8.938 1.623-1.905 1.905-.265 6.591-1.623 8.939-1.339 2.314-6.228 3.226-6.935 5.87-.683 2.554 3.077 5.78 3.077 8.55 0 2.77-3.76 5.997-3.077 8.552.707 2.643 5.596 3.555 6.935 5.869 1.358 2.348-.282 7.034 1.623 8.939 1.905 1.905 6.591.264 8.938 1.622 2.314 1.34 3.226 6.229 5.87 6.935 2.554.683 5.78-3.077 8.55-3.077 2.771 0 5.997 3.76 8.552 3.077 2.643-.706 3.555-5.596 5.87-6.935 2.347-1.358 7.033.282 8.938-1.623 1.906-1.905.265-6.591 1.623-8.939 1.339-2.314 6.228-3.226 6.935-5.87.683-2.553-3.077-5.78-3.077-8.55Z"
    />
    <path
      fill="#fff"
      d="M45.267 58.558 32.825 45.363a1.573 1.573 0 1 1 2.29-2.158l9.771 10.364L57.244 35.65a1.573 1.573 0 0 1 2.59 1.786L45.267 58.558Z"
    />
  </svg>
)
export default CheckedHouseSvg
